import { render, staticRenderFns } from "./Championship.vue?vue&type=template&id=cd2982e2&"
import script from "./Championship.vue?vue&type=script&lang=js&"
export * from "./Championship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports